import { Container, Result, Card, Form, Text } from "../../../components";
import Localization from "../../../localization";

const View = ({
  refs = {},
  email = "",
  fields = [],
  invalidLink = false,
  resetPassword = () => {},
}) => {
  if (invalidLink)
    return (
      <Container>
        <Result
          status="404"
          title={Localization.reset_password.invalid_link_title}
          subTitle={Localization.reset_password.invalid_link_desc}
        />
      </Container>
    );
  return (
    <Container className="m-80-t">
      <Card title={Localization.reset_password.title}>
        <Text color="gray" className="m-15-b">
          {`${Localization.reset_password.desc} `}
          <Text level="text" children={email} />
          {" ."}
        </Text>
        <Form ref={refs.form} fields={fields} />
        <Form.Submit
          type="primary"
          className="w-100 m-40-t"
          onClick={resetPassword}
          title={Localization.reset_password.btn}
        />
      </Card>
    </Container>
  );
};

export default View;
